import { DynamicStandaloneIcon } from '@/components/Icon';
import { componentClassName } from '@/styles/SoMe';
import { ClassNameProp, Component, ComponentProps } from '@/types/component';
import { SocialMediaType } from '@/types/config';
import { cn } from 'lib/utils/cn';
import mergeProps from 'lib/utils/mergeProps';

export interface SoMeProps extends ComponentProps<'button'> {
  name?: SocialMediaType;
  colors?: ClassNameProp<'plain' | 'filled' | 'border'>;
}

const SoMeComponent: Component<SoMeProps> = ({ children, name, theme, colors, size, variant, ...props }) => {
  const classNameProps = { colors, size, variant };
  const classNameDefaults = { colors: 'filled' };

  const className = cn(componentClassName('', classNameProps, { defaults: classNameDefaults, theme }));

  return (
    <button {...mergeProps({ type: 'button', className }, props)}>
      <DynamicStandaloneIcon name={name} />
      {children}
    </button>
  );
};

export const SoMe = SoMeComponent;
